import { api } from "../util/api";
export async function getOrderDetailExcel(body: any) {
  return api.post("/output/excel/order-detail", body);
}
export async function getCustomerOrderExcel(body: any) {
  return api.post("/output/excel/customer-order", body);
}

export async function getOrderDetailPdf(body: any) {
  return api.post("/output/pdf/order-detail", body);
}

function buildOrderSequenceFormData(body: any, orderSequenceFile: File) {
  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  });
  formData.append("orderSequenceFile", orderSequenceFile);
  return formData;
}

export async function getCustomerOrderPdf(body: any, orderSequenceFile?: File) {
  if (orderSequenceFile) {
    return api.post(
      "/output/pdf/customer-order",
      buildOrderSequenceFormData(body, orderSequenceFile)
    );
  }
  return api.post("/output/pdf/customer-order", body);
}

export async function getCustomerOrderPdfV2(body: any, orderSequenceFile?: File) {
  if (orderSequenceFile) {
    return api.post(
      "/output/pdf/customer-order-v2",
      buildOrderSequenceFormData(body, orderSequenceFile)
    );
  }
  return api.post("/output/pdf/customer-order-v2", body);
}

export async function getOrderDetailA6Pdf(body: any, orderSequenceFile?: File) {
  if (orderSequenceFile) {
    return api.post(
      "/output/pdf/order-detail-a6",
      buildOrderSequenceFormData(body, orderSequenceFile)
    );
  }
  return api.post("/output/pdf/order-detail-a6", body);
}

export async function getCustomerOrderByExcelFromOrderIds(body: any) {
  return api.post("/output/excel/order-ids", body);
}
